import React, { useState, useEffect, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import Layout from '../../views/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Services from '../../services/global.service';
import DeleteModal from '../../components/modals/delete';

function Annonces({ status }) {
  const [annonces, setAnnonces] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [action, setAction] = useState('');
  const [idToDeleted, setIdToDelete] = useState('');
  const [filterText, setFilterText] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FCFCFC',
        fontSize: "16px",
      },
    },
    headCells: {
      style: {
        backgroundColor: '#F4F3F3',
        fontSize: "16px",
        fontFamily: 'Lato-Bold',
        fontWeight: '600',
      }
    },
    rows: {
      style: {
        cursor: 'pointer',
        backgroundColor: "#fff",
        fontSize: "16px",
        fontFamily: 'Lato-Light',
        minHeight: '64px'
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'Lignes par page',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Tous',
  };

  function handleDelete(id) {
    setIdToDelete(id);
    setIsOpenDelete(true);
  }

  const columns = [
    {
      name: 'ID annonce',
      selector: row => row.reference,
      sortable: true,
      sortFunction: (a, b) => a.reference.localeCompare(b.reference)
    },
    {
      name: "Nom de l'annonce",
      selector: row => row.name,
      sortable: true,
      sortFunction: (a, b) => a.name.localeCompare(b.name)
    },
    {
      name: 'Prix',
      selector: row => `${row.price} €`,
      sortable: true,
      sortFunction: (a, b) => a.price - b.price
    },
    {
      name: 'Département de réception',
      selector: row => row.dept,
      sortable: true,
      sortFunction: (a, b) => a.dept.localeCompare(b.dept)
    },
    {
      name: 'Date max souhaitée',
      selector: row => new Date(row.receptionDate).toLocaleDateString('fr-FR'),
      sortable: true,
      sortFunction: (a, b) => new Date(a.receptionDate) - new Date(b.receptionDate)
    },
    {
      name: "Statut de l'annonce",
      selector: row => row.status,
      sortable: true,
      cell: row => (
        <span>
          {row.status === "published" ? "Publiée" :
            row.status === "scheduled" ? "Programmée" :
              row.status === "inProgress" ? "En cours" :
                row.status === "completed" ? "Terminée" :
                  row.status === "suspended" ? "Suspendue" :
                    row.status === "archived" ? "Archivée" :
                      row.status === "deleted" ? "Supprimée" : ""}
        </span>
      ),
      sortFunction: (a, b) => a.status.localeCompare(b.status)
    },
    {
      name: "",
      cell: row => (
        <div className="btn-group" role="group" aria-label="Basic example">
          {(row?.status !== 'archived' && row?.status !== "deleted") && (
            <button
              type="button"
              className='btn-secondary-ko'
              onClick={() => {
                handleDelete(row._id);
                setIdToDelete(row._id);
                setAction('archived');
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const subHeaderComponent = useMemo(() => {
    return (
      <div className='col-md-12'>
        <input
          className='form-control'
          id="search"
          type="text"
          placeholder="Recherche"
          value={filterText}
          onChange={e => setFilterText(e.target.value)}
        />
      </div>
    );
  }, [filterText]);

  useEffect(() => {
    if (annonces) {
      const filtered = annonces.filter(item => {
        return JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase());
      });
      setFilteredItems(filtered);
    }
  }, [filterText, annonces]);

  function getAnnonces() {

    console.log("my status", status);
    const url = status ? `annonce/getAllAdmin?status=${status}` : 'annonce/getAllAdmin';
    Services.getAllAdmin(url, localStorage.getItem('token'))
      .then((response) => {
        setAnnonces(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const hideModal = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const DeleteAnnonce = () => {
    const data = {
      status: action
    };
    Services.patch(data, idToDeleted, 'annonce/status')
      .then((res) => {
        getAnnonces();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAnnonces();
  }, [idToDeleted, isOpenDelete,status]);

  return (
    <Layout>
      {isOpenDelete && (
        <DeleteModal
          isOpenDelete={isOpenDelete}
          setIsOpenDelete={setIsOpenDelete}
          hideModal={hideModal}
          Function={DeleteAnnonce}
          title="Souhaitez-vous supprimer/archiver cette annonce ?"
        />
      )}
      <div className="col bg-fond container-k">
        <div className="m-vh-100 p-40">
          <div className="container">
            <div className="d-flex justify-content-between">
              <h1 className="d-title">Liste Annonces {status === 'completed' ? 'Terminées' : status === 'pending' ? 'En Attente' : 'Archivées'} <span className="border-title"></span></h1>
            </div>
            <div className="space-72"></div>
          </div>
          <div className="koper">
            {annonces && (
              <DataTable
                columns={columns}
                onRowClicked={(row) => {
                  window.location.href = `/annonces/${row._id}`;
                }}
                data={filteredItems}
                className="datatable-all mt-24"
                pagination
                paginationComponentOptions={paginationComponentOptions}
                customStyles={customStyles}
                subHeader
                subHeaderComponent={subHeaderComponent}
                noDataComponent={<div className="p-3">Aucune annonce trouvée</div>}
                defaultSortFieldId={5}
                defaultSortAsc={false}
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Annonces;
